module.exports = __webpack_public_path__ + "static/media/md-arrow-dropup-circle.43c410cf.svg";